export default "/_next/static/chunks/fonts/Roboto-Black-latin-e012f6c37cb2ac7456d679f5b5781a51.woff2";